export default __webpack_public_path__ + "static/workingguideimage3-4c941e240c1937a65e0c08eeb462602f.jpeg";